import styled, { css } from 'styled-components';
import { colors } from '@alixpartners/ui-components';

export const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
	padding: 40px 0;
`;

export const Row = styled.div`
	display: flex;
	height: 48px;
	padding: 0 12px;
	align-items: center;
	border-top: 1px solid ${colors.grey4};
	background-color: white;

	&:last-child {
		border-bottom: 1px solid ${colors.grey4};
	}
`;

export const Label = styled.div`
	font-size: 16px;
	line-height: 24px;
	padding: 0 16px;
	color: ${colors.grey8};
	flex: 1;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;

	${({ onClick }) =>
		onClick &&
		css`
			color: ${colors.green2};
			cursor: pointer;

			&:hover {
				color: ${colors.green3};
			}
		`};
`;

export const Helper = styled.div`
	color: black;
	font-size: 11px;
	line-height: 13px;
	padding: 0 8px;
`;

export const DownloadLink = styled.a`
	font-size: 13px;
	font-weight: 500;
	text-transform: uppercase;
	color: ${colors.grey8};
	padding: 0 8px;
	height: 36px;
	line-height: 36px;
	display: inline-block;
`;

export const AuthorLabel = styled.div`
	font-size: 14px;
	line-height: 24px;
	font-weight: 500;
	padding: 0 16px;
	flex: 1;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
`;

export const PublishedBy = styled.div`
	font-size: 14px;
	line-height: 24px;
	font-weight: 500;
	padding: 0 8px;
`;

export const Download = styled.div`
	font-size: 14px;
	line-height: 24px;
	font-weight: 500;
	padding: 0 0 0 8px;
`;

export const Description = styled.div`
	font-size: 13px;
	letter-spacing: 0.3px;
	line-height: 19px;
	color: ${colors.grey5};
	letter-spacing: 0.3px;
	margin-bottom: 15px;
`;

export const ColumnWrapper = styled.div`
	display: flex;
	flex-direction: row;
	width: 100%;
	padding: 10px 0;
`;

export const LeftColumn = styled.div`
	flex: 1;
`;